import React from 'react';
import { classes, st } from './Header.st.css';
import { Filters } from '../../../../shared/components/Filters/Filters';
import { useWidgetViewModel } from '../../hooks/useWidgetViewModel';
import { WeeklyDatePicker } from '../../../../shared/components/WeeklyDatePicker/WeeklyDatePicker';
import { Title } from '../../../../shared/components/Title/Title';
import { Timezone } from '../../../../shared/components/Timezone/Timezone';
import { HeaderDataHooks } from './const';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { FiltersModal } from '../../../../shared/components/Filters/FiltersModal/FiltersModal';

export const Header: React.FC = () => {
  const {
    isInitDataLoading,
    titleViewModel,
    filtersViewModel,
    timeZoneViewModel,
  } = useWidgetViewModel();

  const { isMobile, isRTL } = useEnvironment();

  const HeaderContent = () => (
    <div className={classes.headerContent}>
      <div className={classes.headerTitle}>
        <Title titleViewModel={titleViewModel} />
      </div>
      {isMobile && (
        <FiltersModal
          filtersViewModel={filtersViewModel}
          timeZoneViewModel={timeZoneViewModel}
        />
      )}
    </div>
  );

  const DesktopFilters = () => (
    <div className={classes.filters} data-hook={HeaderDataHooks.FiltersWrapper}>
      <div className={classes.timeZoneWrapper}>
        <Timezone timeZoneViewModel={timeZoneViewModel} />
      </div>
      <Filters filtersViewModel={filtersViewModel} />
    </div>
  );

  return (
    <div
      className={st(classes.root, { isMobile, isRTL })}
      data-hook={HeaderDataHooks.Main}
    >
      <HeaderContent />
      {!isInitDataLoading && (
        <div
          className={classes.filtersContainer}
          data-hook={HeaderDataHooks.FiltersContainer}
        >
          <div
            className={classes.weeklyDatePicker}
            data-hook={HeaderDataHooks.WeeklyDatepickerContainer}
          >
            <WeeklyDatePicker />
          </div>
          {!isMobile && <DesktopFilters />}
        </div>
      )}
    </div>
  );
};
